var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h-row"},_vm._l((_vm.indicators),function(i){return _c('span',{key:i[0],staticClass:"hb-flag",class:i[2] ? i[1] : '',attrs:{"title":i[0]}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }